export const EXSBPOSITION_DELETE_RESET = 'EXSBPOSITION_DELETE_RESET'
export const EXSBPOSITION_DELETE_SET_ERROR = 'EXSBPOSITION_DELETE_SET_ERROR'
export const EXSBPOSITION_DELETE_SET_DELETED = 'EXSBPOSITION_DELETE_SET_DELETED'
export const EXSBPOSITION_DELETE_TOGGLE_LOADING = 'EXSBPOSITION_DELETE_TOGGLE_LOADING'
